export default __webpack_public_path__ + "static/cosmeticCLLogo-1e364c13f6fe72f2c75e5db19e15afac.webp";